export const SCRIPTS_SOURCES = {
  DEVICE_MANAGEMENT: '/deviceManagement/deviceManagementScripts',
  DEVICE_SHELL: '/deviceManagement/deviceShellScripts',
  CONFIGURATION_POLICIES: '/deviceManagement/configurationPolicies',
}
